import React from 'react';

const GreenBoxIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.66675 23.3333C8.66675 14.5337 8.66675 10.134 11.5713 7.4003C14.4758 4.66663 19.1506 4.66663 28.5001 4.66663H30.3031C37.9126 4.66663 41.7173 4.66663 44.3596 6.52824C45.1166 7.06162 45.7887 7.69418 46.3554 8.4067C48.3334 10.8935 48.3334 14.4745 48.3334 21.6363V27.5757C48.3334 34.4898 48.3334 37.9468 47.2392 40.7079C45.4802 45.1466 41.7601 48.6479 37.0439 50.3035C34.1103 51.3333 30.4372 51.3333 23.091 51.3333C18.8932 51.3333 16.7943 51.3333 15.1179 50.7448C12.4229 49.7988 10.2972 47.7981 9.292 45.2616C8.66675 43.6839 8.66675 41.7084 8.66675 37.7575V23.3333Z"
        stroke="#32CD32"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path
        d="M48.3333 28C48.3333 32.2955 44.8511 35.7778 40.5556 35.7778C39.0021 35.7778 37.1706 35.5056 35.6601 35.9103C34.3181 36.2699 33.2699 37.3181 32.9103 38.6601C32.5056 40.1706 32.7778 42.0021 32.7778 43.5556C32.7778 47.8511 29.2955 51.3333 25 51.3333"
        stroke="#32CD32"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 16.3334H35.5001"
        stroke="#32CD32"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 25.6666H26.1667"
        stroke="#32CD32"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GreenBoxIcon;
